import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

const trackGuardedReleasePhasesEvent = createTrackerForCategory('Guarded Rollouts');
const trackProgressiveReleasePhasesEvent = createTrackerForCategory('Progressive Rollouts');

type ReleaseRuleType = 'new' | 'existing' | 'fallthrough';
type DropdownRolloutMode =
  | 'unset'
  | 'variation'
  | 'percentage'
  | 'migration'
  | 'experiment'
  | 'guarded'
  | 'progressive';

const trackMetricsSaveClicked = ({ metrics, previousMetrics }: { metrics: string[]; previousMetrics?: string[] }) =>
  trackGuardedReleasePhasesEvent('Metrics Save Clicked', {
    metrics,
    previousMetrics,
  });

const trackMetricsSelected = ({ metrics }: { metrics: string[] }) =>
  trackGuardedReleasePhasesEvent('Metrics Selected', { metrics });
const trackReleaseStrategyBackClicked = () => trackGuardedReleasePhasesEvent('Release Strategy Back Clicked');

const trackReleaseSelectedFromDropdown = ({
  mode,
  ruleType,
}: {
  mode: DropdownRolloutMode;
  ruleType: ReleaseRuleType;
}) => {
  if (mode === 'guarded') {
    trackGuardedReleasePhasesEvent('Guarded Rollout Selected From Dropdown', { ruleType });
  } else if (mode === 'progressive') {
    trackProgressiveReleasePhasesEvent('Progressive Rollout Selected From Dropdown', { ruleType });
  }
};

const trackSandboxButtonClicked = ({ cta, isTrial }: { cta: string; isTrial: boolean }) =>
  trackGuardedReleasePhasesEvent('Guarded Rollout Upsell Sandbox Demo Button Clicked', { cta, isTrial });
const trackReadBlogPostButtonClicked = () =>
  trackGuardedReleasePhasesEvent('Guarded Rollout Upsell Read Blog Post Button Clicked');
const trackEmptyStateLearnMoreButtonClicked = () =>
  trackGuardedReleasePhasesEvent('Guarded Rollout Empty State Learn More Button Clicked', { location: 'Empty State' });
const trackGuardedReleasePhaseUpsellViewed = ({ isTrial }: { isTrial: boolean }) =>
  trackGuardedReleasePhasesEvent('Guarded Rollout Upsell Viewed', { isTrial });
const trackGuardedReleasePhasePageViewed = () => trackGuardedReleasePhasesEvent('Guarded Rollout Page Viewed');
const trackGuardedReleasePhaseFlagListViewed = () => trackGuardedReleasePhasesEvent('Guarded Rollout Flag List Viewed');
const trackGuardedReleasePhaseConfigAbandoned = () =>
  trackGuardedReleasePhasesEvent('Guarded Rollout Config Abandoned');

// This can probably be moved to a different file later - entitlements package?
const trackUsageLimitTrialEvent = createTrackerForCategory('Usage Limit Trials');

const trackUsageAlertViewed = ({ component, header, status }: { component: string; header: string; status: string }) =>
  trackUsageLimitTrialEvent('Usage Alert Viewed', {
    component,
    header,
    status,
  });
const trackUsageAlertDismissed = ({
  component,
  header,
  status,
}: {
  component: string;
  header: string;
  status: string;
}) =>
  trackUsageLimitTrialEvent('Usage Alert Dismissed', {
    component,
    header,
    status,
  });

export {
  trackReleaseSelectedFromDropdown,
  trackMetricsSaveClicked,
  trackMetricsSelected,
  trackReleaseStrategyBackClicked,
  trackGuardedReleasePhaseUpsellViewed,
  trackGuardedReleasePhasePageViewed,
  trackSandboxButtonClicked,
  trackGuardedReleasePhaseFlagListViewed,
  trackGuardedReleasePhaseConfigAbandoned,
  trackReadBlogPostButtonClicked,
  trackEmptyStateLearnMoreButtonClicked,
  trackUsageAlertViewed,
  trackUsageAlertDismissed,
};
